import { defineModule } from 'direct-vuex'
import { moduleActionContext } from '..'

export enum PresetTestMessages {
  updateSuccess='Successfully updated test!',
  updateFail='Failed to update test.',
  keyInsightSuccess='Successfully updated key insight!',
  keyInsightFail='Failed to update key insight.',
  projectAssociationFail='Failed to update project associations.'
}

export enum WorkspaceSettingsMessages {
  inviteUserSuccess = 'Successfully invited user.',
  addUserSuccess = 'Successfully added user.',
  removeUserSuccess = 'Successfully removed user.',
  updateColorSuccess = 'Successfully updated colors.'
}
export interface NotificationState {
  message: string | false,
  currentTimeout: number | null
}

const createInitialState = (): NotificationState => ({
  message: false,
  currentTimeout: null
})

const notification = defineModule({
  namespaced: true,
  state: createInitialState,
  getters: {
  },
  mutations: {
    changeMessage (state: NotificationState, message: string | false) {
      state.message = message
    },
    saveTimeout (state: NotificationState, timeout: number | null) {
      state.currentTimeout = null
    }
  },
  actions: {
    setMessage (context, message: string | false) {
      const { commit, state } = notificationActionContext(context)
      if (state.currentTimeout) {
        clearTimeout(state.currentTimeout)
      }
      commit.changeMessage(message)
      const timeout = window.setTimeout(() => {
        commit.changeMessage('')
      }, 3000)
      commit.saveTimeout(timeout)
    },
    reset (context) {
      const { commit } = notificationActionContext(context)
      commit.changeMessage('')
    }
  }
})

export default notification
export const notificationActionContext = (context: any) => moduleActionContext(context, notification)
